const membersUtils = {
    /**
     * @typedef {import('@functions/state/types').WorkspaceMember} WorkspaceMember
     * @param {WorkspaceMember} member - The member of the workspace
     * @returns {boolean} - Whether the member is a Roboflow employee
     */
    isRoboflowMember: function (member) {
        return member.email.endsWith("@roboflow.com");
    },

    /**
     * @typedef {import('@functions/state/types').WorkspaceMember} WorkspaceMember
     * @param {WorkspaceMember} member - The member of the workspace
     * @returns {boolean} - Whether the member counts towards the usage limit
     */
    memberCountsTowardUsageLimit: function (member) {
        return !membersUtils.isRoboflowMember(member);
    },

    /**
     * @typedef {Record<string, import('@functions/state/types').WorkspaceMember>} WorkspaceMembersMap
     * @param {WorkspaceMembersMap} members - The members of the workspace
     * @returns {WorkspaceMembersMap} - The members that count towards the usage limit
     */
    getMembersCountingTowardUsageLimitMap: function (members) {
        return Object.entries(members || {}).reduce((acc, [id, member]) => {
            if (membersUtils.memberCountsTowardUsageLimit(member)) {
                acc[id] = member;
            }
            return acc;
        }, {});
    }
};

module.exports = membersUtils;
